export const getFormattedNumber = function (value: number | undefined | null, numberOfDecimals = 2, rawValue = false): string {
  if (!value && value !== 0) {
    return '-';
  }
  const fixedValue = value.toFixed(numberOfDecimals);
  return rawValue ? fixedValue : fixedValue.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
};
